import useSWR from 'swr';
import { useMemo } from 'react';

import { fetcher, endpoints } from 'src/lib/axios';

import { prepareJobsForLLM } from '../utils';

const EMPTY_ITEMS: any[] = [];

export function useGlobalJobsSearchData() {
  const { data, error, isLoading } = useSWR(endpoints.jobs.list, fetcher, {
    dedupingInterval: 3600000,
  });
  const jobItems = Array.isArray(data?.Items) ? data.Items : EMPTY_ITEMS;

  const jobsForLlm = useMemo(() => prepareJobsForLLM(jobItems), [jobItems]);

  return {
    rawJobs: jobItems,
    jobsForLlm,
    isLoading,
    error,
  };
}
